import { shutdown } from '@intercom/messenger-js-sdk';
import Keycloak, { KeycloakLogoutOptions } from 'keycloak-js';

export const keycloak = new Keycloak({
  realm: 'Natter',
  url: window._env_.VITE_APP_AUTH_URL,
  clientId: 'natter-frontend',
});

const originalLogout = keycloak.logout.bind(keycloak);

keycloak.logout = async (options?: KeycloakLogoutOptions) => {
  shutdown();
  return originalLogout({ redirectUri: window.location.origin, ...options });
};

keycloak.onAuthLogout = () => {
  keycloak.logout();
};
